export enum HomeButtonClickEventName {
  RUN_DIAGNOSE = "RUN_DIAGNOSE",
  RERUN_DIAGNOSYS = "RERUN_DIAGNOSYS",
}
export enum LoginButtonClickEventName {
  LOGIN_GOOGLE = "LOGIN_GOOGLE",
  LOGIN_FACEBOOK = "LOGIN_FACEBOOK",
  SIGN_IN = "SIGN_IN",
  RECOVERY_PASSWORD = "RECOVERY_PASSWORD",
  SIGN_UP = "SIGN_UP",
}

export enum QuizButtonClickEventName {
  SEARCH_SPOTIFY_PROFILE = "SEARCH_SPOTIFY_PROFILE",
  SEARCH_YOUTUBE_PROFILE = "SEARCH_YOUTUBE_PROFILE",
  SEARCH_INSTAGRAM_PROFILE = "SEARCH_INSTAGRAM_PROFILE",
  NEXT = "NEXT",
}

export enum SignUpButtonClickEventName {
  LOGIN = "LOGIN",
  LOGIN_GOOGLE = "LOGIN_GOOGLE",
  LOGIN_FACEBOOK = "LOGIN_FACEBOOK",
  RESEND_CODE = "RESEND_CODE",
  VERIFY_CODE = "VERIFY_CODE",
  REGISTER = "REGISTER",
}

export enum AdvanceButtonClickEventName {
  REQUEST = "REQUEST",
  NEXT = "NEXT",
}

export enum DistroButtonClickEventName {
  SIGN_CONTRACT = "SIGN_CONTRACT",
  NEXT = "NEXT",
}
